import { useMemo } from 'react';
import { useFeedActions } from '../data/feed/useFeedActions';
import { InfoDataActions } from '../data/global/actions/InfoActions';
import { useStateSelector } from '../data/global/dataSelectors';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { SymbolChannels } from '../types';
import { BlockActions } from '../data/global/actions';
import { useBlockActions, useBlockData } from '../components/blocks/BlockState';

export const useNews = () => {
  const dispatch = useDispatch();
  const apiToken = useStateSelector(state => state.auth.apiToken);
  const marketNews = useStateSelector(s => s.information.marketNews);
  const { sendNewsSymbolsRequest } = useFeedActions(apiToken);
  const allBlockData: {} = useBlockData();
  const { setField } = useBlockActions<any>();

  function mergeArrays(arr1: SymbolChannels[], arr2: SymbolChannels[]) {
    const map = new Map();

    // Function to add items to the map
    const addToMap = (item: SymbolChannels) => {
      if (!map.has(item.name)) {
        map.set(item.name, { ...item });
      } else {
        map.get(item.name).channels = [...new Set([...map.get(item.name).channels, ...item.channels])];
      }
    };

    // Add items from both arrays to the map
    arr1.forEach(addToMap);
    arr2.forEach(addToMap);

    // Convert the map back to an array
    return Array.from(map.values());
  }

  const subscribeBlockSymbols = useMemo(
    () => (blockId: string, requestedSymbols: SymbolChannels[]) => {
      // Build combined list of other block symbols to check against
      let allBlocksKeys: string[] = [];
      let otherBlockSymbols: SymbolChannels[] = [];
      if (marketNews) {
        allBlocksKeys = Object.keys(marketNews);
        allBlocksKeys.forEach(key => {
          // Cycle through all blocks except the requesting block
          if (
            key !== blockId &&
            marketNews[key] &&
            marketNews[key].submittedSymbols &&
            marketNews[key].submittedSymbols.length > 0
          ) {
            otherBlockSymbols = mergeArrays(marketNews[key].submittedSymbols, otherBlockSymbols);
          }
        });
      }

      let updatedRequestedSymbols: SymbolChannels[] = mergeArrays(requestedSymbols, otherBlockSymbols);

      sendNewsSymbolsRequest(updatedRequestedSymbols);

      // dispatch update block action to update block data within the db/store
      // setField('news', requestedSymbols, { persist: true }); //removed for now until further investigated
      const blockData = {
        data: {
          ...allBlockData,
          news: requestedSymbols,
        },
      };
      dispatch(BlockActions.updateBlock({ blockId, blockData }, { persist: true }));
      dispatch(
        InfoDataActions.updateBlockNews({
          blockId: blockId,
          symbols: requestedSymbols,
        })
      );
    },
    [marketNews]
  );

  return { subscribeBlockSymbols };
};
